
import {
    Button,
    Field,
    HStack,
    Flex,
    VStack,
    IconButton,
    Input,
    Stack,
    Badge,
    Text,
    Switch
} from '@chakra-ui/react'

import { CrowdsColorPicker } from './ui/CrowdsColorPicker'
import { LuTrash } from "react-icons/lu"
import { useTranslation } from '../i18n'


const emptyChallenge = () => ({
    id: crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2, 8),
    label: '',
    color: '#00b5d8',
    textColor: '#000000',
    selfieCamera: true,
})

const SingleChallengeEditor = ({ challenge, handleChallengeChange, handleRemoveChallenge, width }) => {
    const { t } = useTranslation()
    return (
        <VStack align="start" gap={1} p={2}
            w={{ base: '100%', sm: 'auto' }}
            border="1px solid"
            borderColor="border.muted"
            borderRadius="md"
        >
            <HStack gap={1}>
                <Input
                    w={width}
                    fontSize="sm"
                    size="sm"
                    placeholder={t('challenges.name')}
                    value={challenge.label}
                    onChange={(e) => handleChallengeChange(challenge.id, 'label', e.target.value)}
                />
                <IconButton
                    aria-label={t('challenges.deleteAria')}
                    size="xs"
                    variant="ghost"
                    onClick={() => handleRemoveChallenge(challenge.id)}
                >
                    <LuTrash />
                </IconButton>


            </HStack>

            <CrowdsColorPicker label={t('challenges.background')} color={challenge.color} editing={true} setColor={(color) => handleChallengeChange(challenge.id, 'color', color)} maxW={width} />
            <CrowdsColorPicker label={t('challenges.text')} color={challenge.textColor || '#000000'} editing={true} setColor={(color) => handleChallengeChange(challenge.id, 'textColor', color)} maxW={width} />
            <Switch.Root
                checked={challenge.selfieCamera ?? true}
                onCheckedChange={(details) => handleChallengeChange(challenge.id, 'selfieCamera', details.checked)}
                size="sm"
            >
                <Switch.HiddenInput />
                <Switch.Control><Switch.Thumb /></Switch.Control>
                <Switch.Label>{t('challenges.selfieCamera')}</Switch.Label>
            </Switch.Root>
        </VStack>
    )
}


const ChallengesEditor = ({ form, setForm }) => {
    const { t } = useTranslation()

    const handleChallengeChange = (id, key, value) => {
        setForm((prev) => ({
            ...prev,
            challenges: prev.challenges.map((c) => (c.id === id ? { ...c, [key]: value } : c)),
        }))
    }

    const addChallenge = () => {
        setForm((prev) => ({ ...prev, challenges: [...prev.challenges, emptyChallenge()] }))
    }

    const removeChallenge = (id) => {
        setForm((prev) => ({ ...prev, challenges: prev.challenges.filter((c) => c.id !== id) }))
    }

    return (

        <Flex direction="row"
            wrap="wrap"
            gap={3}
            w="100%"
        >
            {form?.challenges && form.challenges.map((c) => (
                <SingleChallengeEditor key={c.id} challenge={c} handleChallengeChange={handleChallengeChange} handleRemoveChallenge={removeChallenge} width={{ base: '100%', sm: '220px' }} />
            ))}
            <Button onClick={addChallenge} size="sm" variant="outline">
                {t('challenges.addChallenge')}
            </Button>
        </Flex>
    );
}

const ChallengesList = ({ eventData }) => {

    return (<HStack>
        <HStack gap={2} wrap="wrap">
            {eventData?.challenges?.map((c, i) => (
                // The event document carries no `id` of its own, and seeded or
                // imported challenges may lack one too, so fall back to position.
                <Badge key={c.id ?? i} bg={c.color} color={c.textColor || 'black'}>
                    {c.label}
                </Badge>
            ))}
        </HStack>
    </HStack>);
}


export const Challenges = ({ form, setForm, editing }) => {
    // The settings tab supplies the title; this is just the list or its editor.
    return editing ?
        <ChallengesEditor form={form} setForm={setForm} /> :
        <ChallengesList eventData={form} />
}
